import axios from 'axios';
import { randomn } from '@/lib/utils';
import { kpNotice } from '@/util/notice';
import config from '@/config';

const uuidV1 = require('uuid/v1');
const state = {
  token: '',
  source: 5,
  uuid: sessionStorage.uuid || uuidV1(),
  version: '',
  language: 'zh_CN',
  device_name: '',
  corporation_id: '',
};
const instance = axios.create({
  baseURL: config.BASE_API,
  timeout: 10000,
});

// 添加请求拦截器
instance.interceptors.request.use(
  function (requestConfig) {
    let request_id = '5' + new Date().getTime().toString() + randomn(4);
    requestConfig.headers['kp-request-id'] = request_id;
    requestConfig.headers['kp-token'] = sessionStorage.token || '';
    requestConfig.headers['kp-source'] = state.source;
    requestConfig.headers['kp-uuid'] = state.uuid;
    requestConfig.headers['kp-version'] = state.version;
    requestConfig.headers['kp-language'] = state.language;
    requestConfig.headers['kp-device-name'] = state.device_name;
    requestConfig.headers['kp-corporation-id'] = state.corporation_id;
    sessionStorage.uuid = state.uuid;
    // localStorage.request_id = request_id
    return requestConfig;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

function responseHandler(response, options) {
  let data = response.data;
  if (data.code === 0) {
    options.success(data);
  } else if (data.code === 100000) {
    kpNotice.warning('middle', 2000, '系统内部异常，请稍后再试');
  } else if (data.code === 100001) {
    kpNotice.warning('middle', 2000, '系统升级中，请稍后再试');
  } else if (data.code === 100003) {
    // token过期
    window.location.href = '/';
  } else {
    // options.success(data)
    if (data.code === 150020) {
      options.success(data);
    } else {
      kpNotice.warning('middle', 4000, data.msg + ',' + data.requestId);
      options.error(data);
    }
  }
}

export default {
  config(params) {
    // console.log('grpc的config设置', params)
    state.token = params.token || state.token;
    state.corporation_id = params.corporation_id || state.corporation_id;
  },

  instance,

  call(url, params) {
    return new Promise((resolve, reject) => {
      instance
        .post(url, params)
        .then((response) => {
          // kpNotice.warning('middle', 2000, '测试')
          // resolve(response.data)
          responseHandler(response, {
            success: (data) => {
              resolve(data);
            },
            error: (data) => {
              reject(data);
            },
          });
        })
        .catch((error) => {
          // 此处要补充超时处理
          // kpNotice.warning('middle', 2000, '接口报错' + error)
          reject(error);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/request.js